import PaymentFormsComponent from './PaymentFormsComponent'

export default PaymentFormsComponent
